<template>
    <div class="mb-3">
        <p v-if="listLoading || detailLoading" role="status"><b-icon icon="loading" custom-class="mdi-spin" /> กำลังโหลด template…</p>
        <b-notification v-if="listError" type="is-warning" :closable="false">
            {{ listError }} <b-button :disabled="listLoading" @click="retryList">ลองใหม่</b-button>
        </b-notification>
        <b-notification v-if="detailError" type="is-warning" :closable="false">
            {{ detailError }} <b-button :disabled="detailLoading" @click="$emit('retry-detail')">ลองใหม่</b-button>
        </b-notification>
    </div>
</template>
<script>
export default {
    props: { detailLoading: Boolean, detailError: String },
    computed: {
        listLoading() { return this.$store.state.mytemplateTxt.loading },
        listError() { return this.$store.state.mytemplateTxt.error }
    },
    methods: { retryList() { this.$store.dispatch('mytemplateTxt/ensureList').catch(() => {}) } }
}
</script>
